import { ApplicationContextEnum } from '../../../services/applicationService/enums';
import { Stack } from '../../../core/types/stratus';
import AppInterfaceV1, { AppInterfaceV1Param } from './AppInterfaceV1';
import { AppInterfaceV1Type } from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

let appInterfaceV1: AppInterfaceV1;

function _createAppInterfaceV1(options: AppInterfaceV1Param) {
  const { applicationService } = options;

  return new AppInterfaceV1({
    applicationService
  });
}

export function getAppInterfaceV1(): AppInterfaceV1Type {
  return appInterfaceV1.getInterface();
}

export default async function initializeAppInterfaceV1(
  options: AppInterfaceV1Param
): Promise<AppInterfaceV1Type> {
  if (appInterfaceV1) return appInterfaceV1.getInterface();
  appInterfaceV1 = _createAppInterfaceV1(options);

  return appInterfaceV1.getInterface();
}

/**
 * Create a bare-bones interface without any implementation. The term No-op
 * (NOP) stands for “no operation”.
 * @returns FeatureFlagInterfaceV1Type
 */
export function createNoopAppInterface(): AppInterfaceV1Type {
  return {
    getClientId: function (): string {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getClientId()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },
    getAppName: function (): string {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getAppName()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },
    getPortalStack: function (): Stack {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getPortalStack()',
        message: 'Noop interface method called - returning Stack.dev'
      });
      return Stack.dev;
    },
    getAuthStack: function (): Stack {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getAuthStack()',
        message: 'Noop interface method called - returning Stack.dev'
      });
      return Stack.dev;
    },
    getAppInstanceId: async function (): Promise<string> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getAppInstanceId()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },
    getAppVersion: async function (): Promise<string> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getAppVersion()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },

    getPlatform: async function (): Promise<string> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getPlatform()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },

    getApplicationContext: function (): ApplicationContextEnum {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopAppInterface',
        methodName: 'getApplicationContext()',
        message: 'Noop interface method called - returning WEB_PORTAL context'
      });
      return ApplicationContextEnum.WEB_PORTAL;
    }
  };
}
